/* unplugin-vue-components disabled */import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/UserLogo.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "scroller-item",
    style: {
      height: _vm.miniStyle.height,
      padding: _vm.miniStyle.padding
    }
  }, [_vm.check ? _c('div', {
    staticClass: "check"
  }, [_c('CheckIcon', {
    attrs: {
      "value": _vm.isCheck
    },
    on: {
      "update:value": function ($event) {
        _vm.isCheck = $event;
      }
    }
  })], 1) : _vm._e(), _vm.showImage ? _c('div', {
    staticClass: "img",
    style: {
      width: _vm.miniStyle.imgHeightWidth,
      height: _vm.miniStyle.imgHeightWidth
    }
  }, [_vm.name && _vm.circleImage ? _c('div', [_c(__unplugin_components_0, {
    attrs: {
      "size": 2,
      "url": _vm.imgUrl,
      "name": _vm.name
    }
  })], 1) : _c('img', {
    staticClass: "img-i",
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "font-size-h3-large smy__text-overflow-one-line"
  }, [_vm._t("title")], 2), _vm.size != 'mini' ? _c('div', {
    staticClass: "font-size-h4-large smy__text-overflow-one-line extra",
    class: {
      'extra-log': _vm.logflag
    }
  }, [_vm._t("extra")], 2) : _vm._e(), _c('div', {
    staticClass: "font-size-h4-large content",
    style: {
      marginTop: _vm.miniStyle.contentMarginTop
    }
  }, [_vm._t("content")], 2)]), _c('div', {
    staticClass: "end"
  }, [_vm._t("end")], 2), _vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };